/**
 * @generated SignedSource<<c374dd9aed2d53a8b0a86cf3a0cc93e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseNotificationsSection$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"notificationSection">;
  readonly " $fragmentType": "hooksUseNotificationsSection";
};
export type hooksUseNotificationsSection$key = {
  readonly " $data"?: hooksUseNotificationsSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseNotificationsSection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUseNotificationsSection"
};

(node as any).hash = "898df8dab90d3afe457475c8b3361d87";

export default node;
